<template>
  <ChecklistTableTaskCellWrapper clickable 
                                 data-locator="comments-area"
                                 @click="openSidePaneOnCommentTab"
  >
    <template v-if="item.lastComment">
      <div
            class="comment-wrapper"
          >
            <div class="left-border"/>
            <div class="comment-text text-grey-800">{{ commentText }}</div>
            <div class="text-truncated text-grey-500">{{ authorAndDate }}</div>
          </div>
      <div
          class="comment-wrapper mt-2"
          v-if="item.commentsCount > 0"
        >
          <div class="left-border"/>
          <div class="comment-text text-grey-800">{{ otherComments }}</div>
      </div>
    </template>
    <template v-else>
      <ChecklistTableTaskEmptyCell />
    </template>
  </ChecklistTableTaskCellWrapper>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import { ISOToShortDate } from '@/common/utils/dates'
import { escapeHtml } from '@/common/utils/strings'
import { useTranslation } from '@/common/utils/translation'
import ChecklistTableTaskCellWrapper from '@/project/checklist/table/ChecklistTableTaskCellWrapper.vue'
import ChecklistTableTaskEmptyCell from '@/project/checklist/table/ChecklistTableTaskEmptyCell.vue'
import { ChecklistSection, ChecklistTask } from '@/project/checklist/types'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'

const { t } = useTranslation({ keyPrefix: 'project.checklist.ChecklistTableBody' })


const props = defineProps<{
  item: ChecklistTask;
  parent: ChecklistSection;
}>()

const commentText = computed(() => {
  if (!props.item.lastComment) {
    return ''
  }

  return escapeHtml(props.item.lastComment.message)
})
const authorAndDate = computed(() => {
  if (!props.item.lastComment) {
    return ''
  }

  const { user, createdAt } = props.item.lastComment
  const formattedDate = ISOToShortDate(createdAt, { withArticle: true })

  return `${user.fullName}, ${formattedDate}`
})

const otherComments = computed(() => {
  if (props.item.commentsCount > 0 ) {
    return t('nbOtherComments', {
      count: props.item.commentsCount,
    })
  }
  return ''
})

const store = useStore()
const openSidePaneOnCommentTab = () => {
  store.dispatch(`checklist/${OPEN_CHECKLIST_PANE}`, {
    isOpen: true,
    parent: props.parent,
    tab: 'comments',
    tasks: [props.item],
  })
}
</script>

<style scoped lang="scss">
.comment-wrapper {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 8px;
}

.left-border {
  border-left: 3px rgb(var(--v-theme-grey-100)) solid;
  border-radius: 3px;
  grid-row: span 2;
}

.comment-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
</style>
